import * as React from "react";
const SvgFiRrSeller = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-seller_svg__a)">
      <path
        fill="#062147"
        d="M23.978 16.306c-.137.959-.906 1.694-1.836 1.694h-.619c-1.026 0-1.857-.895-1.857-2 0 1.105-.831 2-1.857 2h-.619c-1.026 0-1.857-.895-1.857-2 0 1.105-.831 2-1.857 2h-.619c-.929 0-1.699-.735-1.836-1.694a1.14 1.14 0 0 1 .095-.589l.355-.861A3 3 0 0 1 14.244 13h6.509a3 3 0 0 1 2.773 1.856l.355.861c.077.186.124.39.095.589zM22 19a1 1 0 0 0-1 1v1c0 .551-.448 1-1 1h-5c-.552 0-1-.449-1-1v-1a1 1 0 1 0-2 0v1c0 1.654 1.346 3 3 3h5c1.654 0 3-1.346 3-3v-1a1 1 0 0 0-1-1M2 6c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6m2 0c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4m4 8c-4.411 0-8 3.589-8 8v1a1 1 0 1 0 2 0v-1c0-3.309 2.691-6 6-6a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-seller_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSeller;
